<template>
	<div class="layout">
		<div class="layout__header">
			<div class="layout__title">
				<h3>{{ form.id ? 'Editar movimiento de caja' : 'Movimiento de caja' }}</h3>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<input-field id="valor_abono" v-model="form.valor" vMoney :format="money"
						placeholder="Escriba un valor...">
						$ Valor
						<span v-if="errores.valor" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.valor[0] }}</strong>
						</span>
					</input-field>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field">
					<div class="datepicker-field">
						<VueCtkDateTimePicker id="fecha" v-model="form.fecha" locale="es" no-label
							button-now-translation="Ahora" format="YYYY-MM-DD HH:mm:ss" formatted="YYYY-MM-DD HH:mm:ss"
							label="Seleccione fecha..." />
						<label>Fecha</label>
						<span v-if="errores.fecha" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.fecha[0] }}</strong>
						</span>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field select2">
					<div class="select2-field">
						<v-select :clearable="false" placeholder="Seleccione..." id="tipo_movimiento"
							v-model="form.tipo_movimiento" :options="tiposMovimiento" index="value"></v-select>
						<label for="tipo_movimiento">Tipo de movimiento</label>
						<span v-if="errores.tipo_movimiento" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.tipo_movimiento[0] }}</strong>
						</span>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field select2">
					<div class="select2-field">
						<v-select :clearable="false" placeholder="Seleccione..." id="tipo_caja" v-model="form.tipo_caja"
							:options="tiposCaja" index="value"></v-select>
						<label for="tipo_caja">Tipo de caja</label>
						<span v-if="errores.tipo_caja" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.tipo_caja[0] }}</strong>
						</span>
					</div>
				</div>
			</div>
			<div class="col-xs-12 col-md-6">
				<div class="form-field select2">
					<div class="select2-field">
						<v-select :clearable="false" placeholder="Seleccione..." id="ruta_id" v-model="form.ruta_id"
							:options="rutas" label="descripcion" index="id"></v-select>
						<label for="ruta_id">Ruta</label>
						<span v-if="errores.ruta_id" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.ruta_id[0] }}</strong>
						</span>
					</div>
				</div>
			</div>
			<div class="col-xs-12">
				<div class="form-field">
					<textarea-field placeholder="Escriba una observación..." id="observacion"
						v-model="form.observacion">
						<span>Observación</span>
						<span v-if="errores.observacion" class="helper-text text-danger" slot="helper">
							<strong>{{ errores.observacion[0] }}</strong>
						</span>
					</textarea-field>
				</div>
			</div>
		</div>

		<div class="modal-buttons">
			<button @click="guardar" class="btn-success">
				<i class="fa fa-save"></i><span>Guardar</span>
			</button>
			<button @click="cancelar" class="btn-danger btn--text">
				<i class="fa fa-times"></i><span>Cancelar</span>
			</button>
		</div>
	</div>
</template>

<script>
import swal from "sweetalert2";
export default {
	props: {
		tiposCaja: {
			type: Array,
			required: false,
			default: function () {
				return [];
			},
		},
		tiposMovimiento: {
			type: Array,
			required: false,
			default: function () {
				return [];
			},
		},
		rutas: {
			type: Array,
			required: false,
			default: function () {
				return [];
			},
		},
		value: {
			type: Object,
			required: true
		},
	},
	data: function () {
		return {
			form: JSON.parse(JSON.stringify(this.value)),
			errores: {},
			selectedBodega: null,
			selectedTipoGasto: null,
			money: money,
			personas: [],
			selectedPersona: null,
			vendedores: []
		};
	},
	methods: {
		guardar: function () {
			swal({
				title: "¿Desea almacenar los datos del movimiento?",
				text: "Se requiere confirmación",
				icon: "question",
				showCancelButton: true,
				confirmButtonText: "Aceptar",
				cancelButtonText: "Cancelar",
			}).then((result) => {
				if (result.value) {
					const esEdicion = !!this.form.id;
					let urlRequest = url + "/prestamos/movimientos";
					let datos = Object.assign({}, this.form);
					if (esEdicion) {
						urlRequest += "/" + this.form.id;
						datos._method = "PUT";
					}
					axios
						.post(urlRequest, datos)
						.then(() => {
							swal(
								esEdicion ? "El movimiento fue actualizado exitósamente." : "El movimiento fue almacenado exitósamente.",
								"Realizado",
								"success"
							);
							this.$emit("saved");
						})

						.catch(({ response }) => {
							const status = response.status;
							if (status == 422) {
								this.errores = response.data.errors;
								swal("Hay errores en el formulario.", "Aviso", "warning");
								return;
							}
							if (status == 409) {
								swal("Aviso", response.data.error, "warning");
								return;
							}
							swal("Hubo un error, intente nuevamente.", "Error", "error");
						});
				}
			});
		},
		cancelar: function () {
			this.$emit("cancelar");
		},
	},
	watch: {
		value: {
			deep: true,
			handler: function (value) {
				this.form = JSON.parse(JSON.stringify(value));
				this.errores = {};
			},
		},
	},
	// mounted: function () {
	// },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/movimientos/MovimientoPrestamo.vue